import { Component } from '@angular/core';
import { AdOptions, AdPosition, AdSize } from 'capacitor-admob';
import { AdmobService } from '../services/admob.service';
import { Plugins } from '@capacitor/core';
import { Platform } from '@ionic/angular';
const { AdMob, Toast } = Plugins;


@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {

  testing = false;
  appId:string;
  adId:string

  constructor(private platform: Platform) {

    if(this.testing){
      console.log('using test ads');
      this.appId = 'ca-app-pub-7214709202845307~7932538132';
      this.adId = 'ca-app-pub-3940256099942544/6300978111';
    }
    else {
      this.appId = 'ca-app-pub-7214709202845307~7932538132';
      this.adId = 'ca-app-pub-7214709202845307/3610149749';
    }

    platform.ready().then(() => {
      AdMob.initialize(this.appId);
    });
  }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.showTabBarBanner();
    });
  }

  showTabBarBanner() {
    const options: AdOptions = {
      adId: this.adId,
      adSize: AdSize.BANNER,
      position: AdPosition.TOP_CENTER,
      hasTabBar: false,  // make it true if you have TabBar Layout.
      tabBarHeight: 56  // you can assign custom margin in pixel default is 56
    };

    // Show Banner Ad
    AdMob.showBanner(options)
      .then(
        async (value: any) => {
          console.log(value);  // true
        },
        (error: any) => {
          console.error(error); // show error
        }
      );
    // Subscibe Banner Event Listener
    AdMob.addListener('onAdLoaded', async (info: boolean) => {
      console.log('Showing TabBar Banner AD.');
    });
  }

}
